import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';

import css from './style.module.scss';
import setQaAttribute from '../../../helpers/setQaAttribute';

interface IProps {
  children: string | ReactNode;
  color?: 'orange' | 'grey';
  className?: string;
  borderRadius?: '16';
  qaId?: string;
}

const Badge: FC<IProps> = ({ children, color, className, borderRadius, qaId }) => (
  <div
    className={classNames(
      css.badge,
      {
        [css[`badge_color_${color}`]]: color,
        [css[`badge_borderRadius_${borderRadius}`]]: borderRadius,
      },
      className,
    )}
    {...setQaAttribute(qaId)}
  >
    {children}
  </div>
);

export default Badge;
